<template>
   <div id="idEditarSimpleClientesTerrestresModal">

        <ui-modal 
            ref="modal" 
            title="Editar Simple Clientes Terrestres"
            transition="scale-up"
            size="large"
            @close="actionSetShowModalEditSimpleClientGroundModal(false)"
        >
            <client-terrestre-form
                :ids = "idsData"
                :closeModal="cerrarModal"
            />

        </ui-modal>
    </div>

</template>

<script>

    // UI Modal
    import UiModal from "keen-ui/src/UiModal";
    import ClientTerrestreForm from './ClientTerrestreForm.vue';
    import { mapState, mapActions } from "vuex";

    export default {
        props: {
            ids  : { type: Array, default: () => [] },
        },
        data(){
             return {
                idsData: []
             }
         },
        components: {
            UiModal,
            ClientTerrestreForm
        },
        computed: {
            ...mapState("serviciosLogisticos", [
                "showModalEditSimpleClientGroundModal",
             ])
        },
        methods : {

            ...mapActions([ "ActionSetZindexTablaModal"]),

            ...mapActions("serviciosLogisticos",[
                "actionSetShowModalEditSimpleClientGroundModal",
            ]),
            openModal(ref) {
                this.ActionSetZindexTablaModal(true);

                this.$refs[ref].open();
            },
            
            closeModal(ref) {
                this.ActionSetZindexTablaModal(false);
                this.$refs[ref].close();
            },
            cerrarModal(){
                this.closeModal('modal');
            },
        },
        watch: {
            showModalEditSimpleClientGroundModal: function( _new ){
                
                this.idsData = _new ? this.ids : [];

                _new ? this.openModal("modal") : this.cerrarModal() ;
            }
        }

    }

</script>

<style>

#idEditarSimpleClientesTerrestresModal .ui-modal--size-large > .ui-modal__wrapper > .ui-modal__container {
    width: 92% !important;
}
</style>